import NotificationManagementComponent from './notification_management.component';
import NotificationManagementCreate from './create';
import NotificationManagementEdit from './edit';
import NotificationManagementAll from './all';

let NotificationManagementModule = angular.module('notificationManagement', [
  NotificationManagementCreate,
  NotificationManagementEdit,
  NotificationManagementAll
  ])

  .component('notificationManagement', NotificationManagementComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('notification_management.edit', {
        url: '/edit/:id',
        component: 'notificationManagementEdit',
        data: {
          requireACL: 'tnt_control_notification_management.edit'
        }
      })

      .state('notification_management.create', {
        url: '/create',
        component: 'notificationManagementCreate',
        data: {
          requireACL: 'tnt_control_notification_management.create'
        }
      })

      .state('notification_management.all', {
        url: '/all/:page',
        component: 'notificationManagementAll',
        data: {
          requireACL: 'tnt_control_notification_management.view'
        }        
      })
  })

  .name;

export default NotificationManagementModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/index.js